
export const AuthEndpoints = {
    basePath: 'oauth',
    endpoints: {
        login: {
            path: '/login',
            method: 'POST',
            get: null,
            fallback: null,
        },
        retrieve: {
            path: '/forgot-password',
            method: 'POST',
            get: null,
            fallback: null,
        },
        checkToken: {
            path: '/check_token/{{token}}',
            method: 'GET',
            get: null,
            fallback: null,
        },
        refreshToken: {
            path: '/token/refresh',
            method: 'POST',
            get: null,
            fallback: null,
        },

    }
}

export default AuthEndpoints;